import { Warehouse, Truck, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { StepHeader, NextButton } from "./StepHeader";

const ServiceCard = ({ id, icon: Icon, title, sub, selected, disabled, disabledNote, onSelect }) => (
  <button data-testid={`service-option-${id}`} disabled={disabled} onClick={onSelect}
    className={`card-sel relative overflow-hidden text-left p-7 rounded-xl border bg-black/50 backdrop-blur ${selected ? "border-primary glow-y" : "border-white/15"} disabled:cursor-not-allowed`}>
    {disabled && <span data-testid={`service-unavailable-${id}`} className="absolute top-5 right-5 z-10 px-3 py-1 rounded-full bg-primary text-black text-xs font-bold">{disabledNote}</span>}
    <div className={disabled ? "opacity-45" : ""}>
    {!disabled && <span className={`absolute top-5 right-5 w-6 h-6 rounded-full grid place-items-center border ${selected ? "bg-primary border-primary text-black" : "border-white/25"}`}>
      {selected && <Check size={14} strokeWidth={3} />}
    </span>}
    <Icon size={38} strokeWidth={1.4} className="text-primary mb-8" />
    <div className="font-display text-xl font-semibold">{title}</div>
    <div className="text-sm text-muted-foreground mt-1">{sub}</div>
    </div>
  </button>
);

export const StepService = ({ ctx }) => {
  const nav = useNavigate();
  const { b, update, config, go } = ctx;
  return (
    <section data-testid="step-service">
      <StepHeader onBack={() => nav("/")} backLabel="Wróć do strony głównej" num={1} title="Wybierz rodzaj usługi" sub="Gdzie ma zostać wykonany detailing?" />
      <div className="grid sm:grid-cols-2 gap-5 max-w-3xl rise d1">
        <ServiceCard id="stationary" icon={Warehouse} title="Detailing stacjonarny" sub="W naszym warsztacie"
          selected={b.service === "stationary"} onSelect={() => update({ service: "stationary" })} />
        <ServiceCard id="mobile" icon={Truck} title="Detailing mobilny" sub="Dojeżdżamy do Ciebie" disabled={!config.mobile_enabled} disabledNote="Dostępny kwiecień–wrzesień"
          selected={b.service === "mobile"} onSelect={() => update({ service: "mobile" })} />
      </div>
      <div className="flex justify-end mt-12 max-w-3xl">
        <NextButton disabled={!b.service} onClick={() => go("package")} />
      </div>
    </section>
  );
};
